// extracted by mini-css-extract-plugin
module.exports = {"title":"e_Fv","excerpt":"e_Gv","container":"e_Hv","imageContainer":"e_Iv","image":"e_Jv","postedBy":"e_Kv","postedByDate":"e_Lv"};